/** @file restoreKeys: the inverse of writing keys, the previous keys at those frames (replace). */
import type { Clip, ClipKey } from '@zilo/pose3d-format/types/clip';
import type { Command } from '../types/command';
import { keyAt } from './keyAt';

/** `clip.setKeys { keys: <previous keys at frames>, merge: 'replace' }`; `{ frame, nodes: {} }` deletes a new key. */
export function restoreKeys(clipName: string, clip: Clip, frames: readonly number[]): Command {
  const keys: ClipKey[] = frames.map((frame) => structuredClone(keyAt(clip, frame) ?? { frame, nodes: {} }));
  return { name: 'clip.setKeys', input: { clip: clipName, keys, merge: 'replace' } };
}
